// src/components/Header.js
import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import { db } from "../firebase";
import { ref, get } from "firebase/database";

const Header = ({ onMenuClick, onSearchClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  const hideMenu = location.pathname === "/login";

  useEffect(() => {
    const phone = localStorage.getItem("currentUser");
    if (!phone) return;

    const userRef = ref(db, "users/" + phone);
    get(userRef).then((snap) => {
      if (snap.exists()) setUser(snap.val());
    });
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        p: { xs: 1, sm: 1.5, md: 2 },
        m: { xs: 1, sm: 2 },
        borderRadius: 2,
        boxShadow: 1,
        backgroundColor: "white"
      }}
    >
      {/* LEFT MENU */}
      {!hideMenu && (
        <IconButton onClick={onMenuClick}>
          <MenuIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
        </IconButton>
      )}

      {/* TITLE */}
      <Typography
        sx={{
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: { xs: "14px", sm: "16px", md: "18px" },
          textAlign: "center",
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
        onClick={() => navigate("/home")}
      >
        SHOOIN STARS
      </Typography>

      {/* RIGHT SIDE */}
      <Box display="flex" alignItems="center" gap={{ xs: 0.5, sm: 1 }}>
        <IconButton onClick={onSearchClick}>
          <SearchIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;